module.exports = __webpack_public_path__ + "img/1.d7c522d4.png";